<script type="text/babel">
export default{
    data () {
        return {
            selectedHero: 'hero-1'
        }
    },
    mounted () {
    },
    props: [],
    computed: {
    },
    methods: {
    }
}
</script>
